import { render, staticRenderFns } from "./party2.vue?vue&type=template&id=2216a124&scoped=true"
import script from "./party2.vue?vue&type=script&lang=js"
export * from "./party2.vue?vue&type=script&lang=js"
import style0 from "./party2.vue?vue&type=style&index=0&id=2216a124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216a124",
  null
  
)

export default component.exports